import { Component, ElementRef, Renderer, OnDestroy } from '@angular/core';
import { SearchbarService } from './searchbar.service';

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class SearchbarComponent implements OnDestroy {
  selectedIndex = 0;
  globalListenFunc: Function;

  constructor(
    private searchbar: SearchbarService,
    private elem: ElementRef,
    private renderer: Renderer
  ) {
    renderer.listenGlobal('document', 'click', (event: any) => {
      if (this.data.length > 0 && event.target && this.elem.nativeElement !== event.target &&
        !this.elem.nativeElement.contains(event.target)) {
        this.data = [];
      }
    });
  }

  data = [];

  getData(data) {
    return new Promise((resolve, reject) => {
      setTimeout(function() {
        resolve(data);
      }, 1000);
    });
  }

  setData(data) {
    this.selectedIndex = 0;
    this.data = data;
  }

  makeSuggestionsArray(suggestions) {
    const tempArray = [];
    let i = 0;
    if (suggestions.recent.length > 0) {
      tempArray.push({
        header: true,
        text: 'Recent Searches'
      });
      for (i = 0; i < suggestions.recent.length; i++) {
        suggestions.recent[i].icon = true;
        suggestions.recent[i].basic = true;
        tempArray.push(suggestions.recent[i]);
      }
    }
    if (suggestions.suggestions.length > 0) {
      tempArray.push({
        header: true,
        text: 'Suggestions'
      });
      for (i = 0; i < suggestions.suggestions.length; i++) {
        suggestions.suggestions[i].basic = true;
        tempArray.push(suggestions.suggestions[i]);
      }
    }
    if (suggestions.categories.length > 0) {
      tempArray.push({
        header: true,
        text: 'Categories'
      });
      for (i = 0; i < suggestions.categories.length; i++) {
        tempArray.push(suggestions.categories[i]);
      }
    }
    if (suggestions.brands.length > 0) {
      tempArray.push({
        header: true,
        text: 'Brands'
      });
      for (i = 0; i < suggestions.brands.length; i++) {
        tempArray.push(suggestions.brands[i]);
      }
    }
    if (suggestions.products.length > 0) {
      tempArray.push({
        header: true,
        text: 'Products'
      });
      for (i = 0; i < suggestions.products.length; i++) {
        tempArray.push(suggestions.products[i]);
      }
    }
    this.setData(tempArray);
  }

  search(keyCode, searchText) {
    if (keyCode === 13) { // Return
      this.clickedEnter(searchText);
    } else if (keyCode === 38) { // Up Arrow
      this.changeSelection(-1);
    } else if (keyCode === 40) { // Down Arrow
      this.changeSelection(1);
    } else { // anything else
      // HTTP IN SERVICE USING SUPPLYHUB API
      this.searchbar.getSupplyHubData(searchText).subscribe(
        data => {
          console.log('data', data);
          this.makeSuggestionsArray(data);
        }
      );
    }
  }

  clickedEnter(searchText) {
    if (this.data.length > 0) {
      if (this.data[this.selectedIndex].header) { // if on header search using searchText
        window.location.href = `https://www.supplyhub.com/products?search=${this.data[this.selectedIndex].text}`;
      } else if (this.data[this.selectedIndex].basic) {
        window.location.href = `https://www.supplyhub.com/products?search=${this.data[this.selectedIndex].text}`;
      } else if (this.data[this.selectedIndex].categorySlug) {
        window.location.href = `https://www.supplyhub.com/products?category=${this.data[this.selectedIndex].categorySlug}`;
      } else if (this.data[this.selectedIndex].brandSlug) {
        window.location.href = `https://www.supplyhub.com/products?brand=${this.data[this.selectedIndex].brandSlug}`;
      } else if (this.data[this.selectedIndex].slug) {
        window.location.href = `https://www.supplyhub.com/products/details/${this.data[this.selectedIndex].slug}`;
      }
    }
  }

  changeSelection(direction: number) {
    if (this.data.length > 0) {
      this.data[this.selectedIndex].selected = false;
      this.selectedIndex += direction;
      // add check for selected header to skip these
      if (this.data[this.selectedIndex] && this.data[this.selectedIndex].header) {
        this.selectedIndex += direction;
      }
      if (this.selectedIndex < 0) { // add check to ensure it does not go less than 0
        this.selectedIndex = 0;
      } else if (this.selectedIndex >= this.data.length) { // and not > suggestions.length
        this.selectedIndex = this.data.length - 1;
      }
      this.data[this.selectedIndex].selected = true;
    }
  }

  ngOnDestroy() {
    // Removes "listenGlobal" listener
    this.globalListenFunc();
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/searchbar/searchbar.component.ts